import * as React from "react";
import { Table, TableBody, TableCell, TableRow } from "@/components/bp/bp-ui";
import { SemanticWIDTHS } from "semantic-ui-react/dist/commonjs/generic";
import { BPBoxWithHeader } from "./BPBoxWithHeader";
import { innerText } from "./Utils";

export interface InfoBoxProps {
    header?: string | React.ReactNode;
    items: Array<{ title?: string, width?: SemanticWIDTHS, label: string | React.ReactNode, description: string | React.ReactNode, align?: 'left' | 'right', showIf?: boolean | null }>;
    compact?: boolean;
    children?: (props) => React.ReactElement;
    forPrint?: boolean;
}
export function InfoBox(props: InfoBoxProps) {
    if (props.children)
        return props.children(props)
    else
        return true || !props.forPrint ? (
            <BPBoxWithHeader forPrint={props.forPrint} header={props.header} compact={props.compact}>
                {/* <div className="ui attached header"/> */}
                <Table definition compact fixed={!props.forPrint} singleLine={!props.forPrint} style={(props.compact ?? false) == false ? {} : { borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                    <TableBody>
                        {props.items.filter(item => item.showIf == null || item.showIf).map((item, idx) => {
                            return (
                                <TableRow key={`${innerText(item.label)}_${innerText(item.description)}_idx`}>
                                    <TableCell width={item.width == null ? 3 : item.width}>{item.label}</TableCell>
                                    <TableCell textAlign={item.align ?? 'left'} title={item.title}>{item.description}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </BPBoxWithHeader>
        ) : (
            <InfoBox compact
                header={props.header}
                forPrint={props.forPrint}
                items={props.items}>{iprops => <>
                    {props.header &&
                        <h4>{props.header}</h4>
                    }
                    <table>
                        <tbody>
                            {iprops.items.filter(item => item.showIf == null || item.showIf).map((item, idx) => {
                                return (
                                    <tr key={`inforow_${idx}`}>
                                        <TableCell width={item.width == null ? 3 : item.width}>{item.label}</TableCell>
                                        <TableCell title={item.title}>{item.description}</TableCell>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>}</InfoBox>
        );
}
